import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  store: {
    fundraiserName?: string;
    schoolName?: string;
    storeNumberDisplay?: string;
  };
  busy?: boolean;
  onConfirm: () => void | Promise<void>;
};

export function ApproveStoreDialog({ open, onOpenChange, store, busy, onConfirm }: Props) {
  const name = store.fundraiserName || store.schoolName || 'this store';
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!busy) onOpenChange(o); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Approve {name}?</DialogTitle>
          <DialogDescription>
            This will create products on Shopify and the store will go live.
            This cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button
            variant="ghost"
            disabled={busy}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={busy}
            onClick={() => { void onConfirm(); }}
          >
            {busy ? 'Approving…' : 'Approve & Create Products'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
